/* @flow */
import type { StatPush } from "../CommonTypes";
import type { Action } from "../action";

type State = {
  [stock: string]: StatPush
};

function receiveSocketMessage(state, payload) {
  switch (payload.op) {
    case "statPush_go":
      return { ...state, [payload.stock]: payload }
    default:
      return state;
  }
}

function stats(state?: State = {}, action: Action): State {
  switch (action.type) {
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    default:
      return state;
  }
}

export default stats;



// WEBPACK FOOTER //
// ./src/redux/reducer/stats.js